import { Routes } from '@angular/router';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { ConversionInfosComponent } from './components/conversion-infos/conversion-infos.component';
import { IsAuthenticatedGuard } from './guards/is-authenticated.guard';
import { ConversionErrorsComponent } from './components/conversion-errors/conversion-errors.component';
import { CustomerMainComponent } from './components/customer-main/customer-main.component';
import { CustomersComponent } from './components/customers/customers.component';
import { ClientsOfCustomerComponent } from './components/clients-of-customer/clients-of-customer.component';
import { StatsComponent } from './components/stats/stats.component';
import { StatsOverviewComponent } from './components/stats-overview/stats-overview.component';
import { ClientStatsComponent } from './components/client-stats/client-stats.component';
import { CustomerStatsComponent } from './components/customer-stats/customer-stats.component';
import { HangfireDashboardComponent } from './components/hangfire-dashboard/hangfire-dashboard.component';
import { ConversionArchiveComponent } from './components/conversion-archive/conversion-archive.component';
import { LoginComponent } from './components/login/login.component';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent
  },
  {
    path: 'conversion-infos',
    component: ConversionInfosComponent,
    canActivate: [IsAuthenticatedGuard]
  },
  {
    path: 'conversion-errors',
    component: ConversionErrorsComponent,
    canActivate: [IsAuthenticatedGuard]
  },
  {
    path: 'customers',
    component: CustomerMainComponent,
    canActivate: [IsAuthenticatedGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list'
      },
      {
        path: 'list',
        children: [
          {
            path: '',
            component: CustomersComponent,
            pathMatch: 'full'
          },
          {
            path: ':customerId',
            component: ClientsOfCustomerComponent
          }
        ]
      },
      {
        path: 'clients',
        component: ClientsOfCustomerComponent
      }
    ]
  },
  {
    path: 'stats',
    component: StatsComponent,
    canActivate: [IsAuthenticatedGuard],
    children: [
      {
        path: 'overview',
        component: StatsOverviewComponent
      },
      {
        path: 'clients',
        component: ClientStatsComponent
      },
      {
        path: 'customers',
        component: CustomerStatsComponent
      },
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'jobs',
    component: HangfireDashboardComponent
  },
  {
    path: 'archive',
    component: ConversionArchiveComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  }
];
